const attributes = {
	formName: { type: 'string', default: 'form-widget-name' },
	formTag: { type: 'array', default: ['EasyTag']},
	formAllIntegration: { type: 'array', default: ['Local Database']},
	formWidth: { type: 'number', default: 1000 },
	formDoubleOptIn: { type: 'boolean', default: false },
	formStyle: { type: 'number', default: 1 },
	headingText: { type: 'string', default: 'Offers & Crazy Deals' },
	subHeadingDisplay: { type: 'boolean', default: true },
	subHeadingText: {
		type: 'string',
		default: 'JOIN OUR MAIL LIST FOR EXCLUSIVE',
	},
	nameFieldDisplay: { type: 'boolean', default: false },
	nameFieldIsRequired: { type: 'boolean', default: false },
	nameFieldPlaceholder: { type: 'string', default: 'Your Name' },
	nameFieldErrorMsg: { type: 'string', default: 'Name field is required' },
	firstnameLastnameFieldDisplay: { type: 'boolean', default: false },
	phoneFieldDisplay: { type: 'boolean', default: false },
	phoneFieldRequired: { type: 'boolean', default: false },
	emailPlaceholder: { type: 'string', default: 'Your Email' },
	emailErrorMsg: {
		type: 'string',
		default: 'Valid email address is required.',
	},
	consentCheckbox: { type: 'boolean', default: true },
	consentText: { type: 'string', default: 'I agree to get updates' },
	consentErrorMsg: {
		type: 'string',
		default: 'Please select "I agree to get updates" option',
	},
	btnText: { type: 'string', default: 'Subscribe Now!' },
	btnSubmisisonAction: { type: 'string', default: 'custom_msg' },
	btnSubmisisonThankYouMsg: {
		type: 'string',
		default: 'You have successfully subscribe to the newsletter',
	},
	btnSubmisisonErrorMsg: {
		type: 'string',
		default: 'There was a problem while submitting. Please try again',
	},
	btnSubmissionThankYouPage: { type: 'string', default: 0 },
	post_id: { type: 'number', default: 0 },

	//design
	backgroundType: { type: 'string', default: 'default' },
	backgroundColor: { type: 'string', default: '#3867D6' },
	color: { type: 'string', default: '#FFFFFF' },
	backgroundImage: { type: 'object', default: null },
};

export default attributes;
